import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { TFunction } from "i18next";
import { MdCheck, MdStarBorder } from "react-icons/md";
import { CustomButton } from "../../../../atoms/CustomButton";
import { StatusBadge } from "../../../../atoms/StatusBadge";
import TemplateDropdown from "./TemplateDropdown";
import { SendMessageFormValues } from "./types";
import { DEFAULT_TEMPLATE, TEMPLATE_OPTIONS } from "./constants";

type TemplateSectionProps = {
  t: TFunction;
  savedDefaultTemplate?: string;
  onSaveDefault?: () => void;
};

const TemplateSection: React.FC<TemplateSectionProps> = ({
  t,
  savedDefaultTemplate,
  onSaveDefault,
}) => {
  const { control } = useFormContext<SendMessageFormValues>();
  const currentTemplate =
    useWatch({ control, name: "template" }) ?? DEFAULT_TEMPLATE;
  const isDefault =
    !!savedDefaultTemplate && savedDefaultTemplate === currentTemplate;

  return (
    <section>
      <Controller
        name="template"
        control={control}
        defaultValue={TEMPLATE_OPTIONS[0]?.value}
        render={({ field }) => (
          <TemplateDropdown value={field.value} onChange={field.onChange} />
        )}
      />
      <p className="mt-3 text-xs text-gray-500">
        <i>
          {t(
            "dashboard.entities.viewEntityUser.sendMsg.helperText.templateTip"
          )}
        </i>
      </p>

      {isDefault ? (
        <div className="mt-2 flex justify-end">
          <StatusBadge color="gray" icon={MdCheck}>
            {t("dashboard.entities.viewEntityUser.sendMsg.isYourDefault")}
          </StatusBadge>
        </div>
      ) : onSaveDefault ? (
        <div className="mt-2 flex justify-end">
          <CustomButton
            variant="none"
            size="xs"
            onClick={onSaveDefault}
            className="gap-1 text-gray-500 enabled:hover:text-blue-700"
            icon={<MdStarBorder size={14} />}
            title={
              t(
                "dashboard.entities.viewEntityUser.sendMsg.setAsDefault"
              ) as string
            }
          />
        </div>
      ) : null}
    </section>
  );
};

export default TemplateSection;
